var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDinersClub = function SvgDinersClub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    fill: "#F8F8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.326 13.134a7.511 7.511 0 1 1 15.022 0 7.511 7.511 0 0 1-15.022 0Z",
    fill: "#FFFFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.38 12.987a4.519 4.519 0 0 0-2.9-4.214V17.2a4.519 4.519 0 0 0 2.9-4.213Zm-6.132 4.211V8.774a4.523 4.523 0 0 0-2.898 4.213 4.521 4.521 0 0 0 2.898 4.211Zm1.617-11.334a7.123 7.123 0 0 0 0 14.243 7.122 7.122 0 0 0 0-14.243Zm-.018 14.916C11.543 20.8 8 17.313 8 13.068c0-4.64 3.543-7.848 7.847-7.848h2.017C22.118 5.22 26 8.427 26 13.068c0 4.243-3.882 7.712-8.136 7.712h-2.017Z",
    fill: "#0069AA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 25,
    rx: 4.5,
    stroke: "#7F939D"
  })));
};
export default SvgDinersClub;